import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { FunctionsService } from "./functions.service";
import { ResolverService } from "./resolver.service";


@Injectable({
  providedIn: 'root',
})
export class RefreshService {

  currentRoute = '';
  private routesToRefresh = ['/sub-app/:id', '/reports', '/users']; // List of routes that require a refresh
  currentlyFetching = [];

  constructor(private router: Router,private resolver: ResolverService,private commonFuntions: FunctionsService) {}

  shouldRefresh(): boolean {
    this.currentRoute = this.router.url;
    return this.routesToRefresh.some((routePattern) => this.matchRoute(routePattern, this.router.url));
  }

  private matchRoute(routePattern: string, currentRoute: string): boolean {
    const regex = new RegExp(`^${routePattern.replace(/:id/, '\\d+')}$`); // Adjust for numeric IDs
    return regex.test(currentRoute) || currentRoute.startsWith(routePattern.replace('/:id', '')); // Support generic matching
  }

  /** Mock function to fetch data */
  fetchData(): Promise<void> {
    switch(this.currentRoute){
      case '/sub-app/visa-helper':
        this.currentlyFetching = [];
        this.currentlyFetching.push('getClientTools');
        this.resolver.getBackendDataForQueryId('getClientTools',true,this.commonFuntions.getSelectedClientId());
        break;
      default:
        break;
    }

    console.log('Fetching data from backend...');
    return new Promise((resolve) => {
      setTimeout(() => {
        console.log('Data refreshed successfully');
        resolve();
      }, 2000); // Simulating an API call
    });
  }

  getCurrentFetchingQueries(){
    return this.currentlyFetching;
  }
}
